import { SortOrder } from 'antd-v5/lib/table/interface';
import { noop } from 'lodash';
import { NameIdPair } from 'types/api/nameIdPair';

import { FilterOperationType } from './api/filterOperationType';
import { KeyValue } from './tenantConfig';

export type SortType = 'string' | 'number' | 'date' | 'severity';

export type SortInfo = {
  [key: string]: SortOrder;
};

export type SortColumn = {
  property: string;
  direction: 'asc' | 'desc';
};

export type SortColumns = SortColumn[];

export { type SortOrder };

export type FilterOptionNameId = { name: React.ReactNode; id: string | number };
export type FilterOptionLabelValue = {
  label: React.ReactNode;
  value: string | number;
};

export type FilterOption =
  | string
  | number
  | FilterOptionNameId
  | FilterOptionLabelValue
  | NameIdPair;

export type FilterOptions = FilterOption[];
export type FilterOptionInfo = { [key: string]: FilterOptions };

export type FilterValue = string | number | KeyValue | boolean | null;
export type FilterInfo = {
  [key: string]: FilterValue[];
};
export type SavedSearchInfo =
  | {
      id: number;
    }
  | undefined;

export type PageChangeCallBack = (page: number, pageSize: number) => void;
export type SortChangeCallBack = (sortInfo: SortInfo) => void;
export type FilterChangeCallBack = (
  filteredInfo: FilterInfo,
  filterOperations?: FilterOperationInfo,
) => void;
export type ResetFiltersCallback = (initialValues?: {
  filters?: FilterInfo;
  savedSearch?: SavedSearchInfo;
  groupBy?: string[];
  sortInfo?: SortInfo;
  pageSize?: number;
  sortString?: string;
  isVisualMode?: boolean;
}) => boolean | void;
export type GroupByChangeCallback = (keys: string[]) => void;

export type PaginationControllerParams = {
  defaultPageSize?: number;
  defaultSortInfo?: SortInfo;
  defaultFilterInfo?: FilterInfo;
};

export type IsVisualModeChangeCallback = (isVisualMode: boolean) => void;

export type PaginationControls = {
  page: number;
  pageSize: number;
  sortInfo: SortInfo;
  sortString?: string;
  filterInfo: FilterInfo;
  filterOperations?: FilterOperationInfo;
  savedSearchInfo?: SavedSearchInfo;
  onPageChange: PageChangeCallBack;
  onSortChange: SortChangeCallBack;
  onFilterChange: FilterChangeCallBack;
  resetFilters: ResetFiltersCallback;
  groupBy?: string[];
  onGroupByChange?: GroupByChangeCallback;
  defaultPageSize: number;
  /** Current Visual/AQL mode state (undefined = use parsing logic) */
  isVisualMode?: boolean;
  /** Callback to update mode in URL */
  setIsVisualMode?: IsVisualModeChangeCallback;
};

export type UrlPagination = {
  page?: number;
  size?: number;
  sort?: string;
};

export type ParsedUrlDetails = {
  filters: FilterInfo;
  pagination?: UrlPagination;
  savedSearch: SavedSearchInfo;
  groupBy: string[];
  isVisualMode?: boolean;
};

export const DummyPaginationControlls: PaginationControls = {
  page: 0,
  pageSize: 0,
  sortInfo: {},
  filterInfo: {},
  onPageChange: noop,
  onSortChange: noop,
  onFilterChange: noop,
  resetFilters: noop,
  groupBy: [],
  onGroupByChange: noop,
  defaultPageSize: 0,
};

export type FilterOperationInfo = Record<string, FilterOperationType>;

export const FilterOperationTypeLabel = {
  [FilterOperationType.contains]: 'Contains',
  [FilterOperationType.notContains]: 'Not Contains',
  [FilterOperationType.startWith]: 'Starts With',
  [FilterOperationType.endWith]: 'Ends With',
  [FilterOperationType.equal]: 'Equals',
  [FilterOperationType.notEqual]: 'Not Equals',
};
